import { config } from './config';
import { api } from './api';
import { user } from './user';
import { events } from './events';
import { polling } from './polling';
import { pagination } from './pagination';

export default {
	config,
	api,
	polling,
	user,
	events,
	pagination,
};
